import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import VueMeta from 'vue-meta';
import { iui } from 'industrial-ui-vue';
import capitalize from '@/utils/formatting/capitalize';
import spaces from '@/utils/formatting/add-spaces';
import { SENTRY_DSN, SENTRY_ENVIRONMENT } from '@/utils/constants/sentry';
import App from '@/./App';
import store from '@/store/index';
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition';
import router from './router';
import { i18n } from './i18n';
import apolloProvider from './apolloProvider';
import './styles/base.scss';

import config from './utils/iui-config';
import prettyDates from '@/utils/formatting/pretty-date';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
  });
}

const myTransition = createSimpleTransition('tippy-transition');
Vue.component('tooltip-transition', myTransition);
Vue.use(Vuetify);

Vue.use(iui, config);
Vue.use(VueMeta, { keyName: 'meta' });
Vue.config.productionTip = false;

Vue.filter('howLong', (date) => prettyDates(date, false, true));
Vue.filter('capitalize', capitalize);
Vue.filter('spaces', spaces);

Vue.directive('on-click-outside', {
  bind: function (el, binding) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event, el);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdiSvg',
    },
  }),
  render: (h) => h(App),
}).$mount('#app');
